<template>
    <NavTabs :list="$props.list" :scrollOffset="scrollOffset" @change="handleChanged" ref="navTab"
        class="wecoupon-mall-navtabs">
        <template v-slot:default="item">
            <div class="tab-sub-item" :class="{ 'item-actived': item.data.actived }">
                <div class="logo">
                    <img :src="item.data.logo" v-if="item.data.logo" />
                </div>
                <div class="name"> {{ item.data.name }}</div>
            </div>
        </template>
    </NavTabs>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue-demi';
import { NavTabs, NavTabsInfo } from '@tencent/wphk-ui';

export default defineComponent({
  name: 'MallNavTabs',
  components: {
    NavTabs,
  },
  emits: ['change'],
  props: {
    list: {
      type: Array as PropType<NavTabsInfo[]>,
      required: true,
    },
  },
  setup(props, context) {
    const navTab = ref<InstanceType<typeof NavTabs> | null>(null);
    // 设置点击滚动边缘触发的距离，点击项离2端小于这个距离会自动滚动展示隐藏项
    const scrollOffset = ref(100);

    function handleChanged(nav) {
      context.emit('change', nav.id);
    }

    function switchTo(id: string) {
      if (navTab.value) {
        navTab.value.switchNavTab(id);
      }
    }

    return {
      navTab,
      scrollOffset,
      handleChanged,
      switchTo,
    };
  },
});
</script>

<style lang="less" scoped>
@import (reference) '../../../less/main.less';

.wecoupon-mall-navtabs {

    /deep/ .tab-container {
        .tab-item {
            vertical-align: bottom;
            margin-left: 16 /@rem !important;

            &:first-child {
                margin-left: 32/@rem !important;
            }

            &:last-child {
                margin-right: 32/@rem !important;
            }
        }

        .tab-bottom {
            text-align: center;

            .line {
                width: 48 /@rem !important;
            }
        }
    }

    .tab-sub-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .logo {
            background-size: 100%;
            width: 102 /@rem;
            height: 102 /@rem;
            background-repeat: no-repeat;
            border-radius: 50%;
            border: 3/ @rem solid #ffffff;
            border-color: #ffffff;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #ffffff;

            img {
                width: 96 /@rem;
                height: 96 /@rem;
                border-radius: 50%;
                border: 1 /@rem solid;
                border-color: rgba(0, 0, 0, 0.1);
                object-fit: cover;

            }
        }

        .name {
            text-align: center;
            width: 132 /@rem;
            font-size: 26 /@rem;
            line-height: 40/@rem;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: rgba(0, 0, 0, 0.5);
            font-size: PingFang HK;
        }

    }

    .item-actived {
        .logo {
            border-color: #07C160 !important;

            img {
                border-color: #ffffff !important;
            }
        }

        .name {
            font-weight: bold;
            color: #000000;
        }
    }

}
</style>

